export const tabs = ["Use Email", "Use Teams"];
